/**
 * Securidou — Problem/Solution V2 Component
 * Handles: scroll reveal (sd-reveal / sd-reveal-stagger), animated stat counter.
 * Loaded with defer — DOM is ready when this runs.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ─── SCROLL REVEAL OBSERVER ─────────────────────── */
  var revealObserver = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    },
    { threshold: 0.12 }
  );

  document.querySelectorAll('.ps-act1-inner.sd-reveal, .ps-act2-inner.sd-reveal').forEach(function (el) {
    if (reducedMotion) {
      el.classList.add('is-visible');
    } else {
      revealObserver.observe(el);
    }
  });

  /* ─── STAGGER OBSERVER ───────────────────────────── */
  var staggerObserver = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    },
    { threshold: 0.05 }
  );

  document.querySelectorAll('.ps-icon-item.sd-reveal-stagger, .ps-testimonial.sd-reveal-stagger').forEach(function (el) {
    if (reducedMotion) {
      el.classList.add('is-visible');
    } else {
      staggerObserver.observe(el);
    }
  });

  /* ─── STAT COUNTER ANIMATION ────────────────────── */
  function animateCounter(el) {
    var raw = el.getAttribute('data-target') || '';
    /* Extract numeric prefix and suffix (e.g. "87%" → prefix="", num=87, suffix="%") */
    var match = raw.match(/^([^0-9]*)([0-9]+(?:[.,][0-9]+)?)(.*)$/);
    if (!match) return;

    var prefix = match[1] || '';
    var numStr = match[2].replace(',', '.');
    var suffix = match[3] || '';
    var target = parseFloat(numStr);
    if (isNaN(target)) return;

    var isFloat = numStr.indexOf('.') !== -1;
    var duration = 1400;
    var startTime = null;

    function tick(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      /* Ease-out cubic */
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = eased * target;
      el.textContent = prefix + (isFloat ? current.toFixed(1) : Math.round(current)) + suffix;
      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = raw;
      }
    }

    requestAnimationFrame(tick);
  }

  if (!reducedMotion) {
    var statObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.5 }
    );

    document.querySelectorAll('.ps-stat-number[data-target]').forEach(function (el) {
      statObserver.observe(el);
    });
  }
})();
